<template>
  <div class="tab-select">
    <ToolTip
      v-for="option in options"
      :key="option.value"
      :delay="[500, 500]"
      :content="option.description"
    >
      <button
        class="tab-select__button"
        :class="{ 'tab-select__button--active': value === option.value }"
        @click="emit('change', option.value)"
      >
        {{ option.label || option.value }}
      </button>
    </ToolTip>
  </div>
</template>

<script lang="ts">
export default {
  name: 'TabSelector',
}
</script>

<script lang="ts" setup>
import type { TabSelectorOption } from './types'
import ToolTip from '@/uiKit/ToolTip/ToolTip.vue'

/**
 * Renders a tab like UI of buttons, one of which has an exclusive active state,
 * toggled when clicked.
 */

defineProps<{
  value: string
  options: TabSelectorOption[]
}>()

const emit = defineEmits<{
  (e: 'change', value: string): void
}>()
</script>

<style lang="scss" scoped>
.tab-select {
  @include row;
}

.tab-select__button {
  padding: 10px 20px;
  background: transparent;

  @include typographyRegularBody200;
  color: var(--color-text-subtle);
  text-transform: capitalize;
  position: relative;
}

.tab-select__button.tab-select__button--active {
  color: var(--color-text-selected);
}

.tab-select__button::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  background: var(--color-background-primary);
  width: 100%;
  height: 2px;
}

.tab-select__button:not(.tab-select__button--active):hover::after {
  background: var(--color-background-gray-subtle-hovered);
  height: 2px;
  opacity: 1;
}

.tab-select__button.tab-select__button--active::after {
  opacity: 1;
}
</style>
